import { courseChaptersFactory } from '@core/components/course/Chapters/factory.ts'
import type { ChaptersInCourseElement } from '@core/components/course/Chapters'
import type { ChaptersInCourse as ChaptersInCourseAPI } from '@jojotique/server'

export const generateCourseChapters = (
  document: Document,
  {
    courseSlug,
    chapters,
  }: {
    courseSlug: string
    chapters: ChaptersInCourseAPI[]
  },
  {
    baseElement,
    customElements,
  }: {
    baseElement: typeof HTMLElement
    customElements: CustomElementRegistry
  },
): void => {
  customElements.define('chapters-in-course', courseChaptersFactory(baseElement))
  const chaptersInCourse = document.createElement('chapters-in-course') as unknown as ChaptersInCourseElement
  chaptersInCourse.initList(courseSlug, chapters, document)
  document
    .querySelector('main section h2')
    ?.insertAdjacentElement('afterend', chaptersInCourse as unknown as HTMLElement)
}
